import _ from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Buttons, CancelButton, Checkbox, Drawer, Form } from '~/components';
import { useDirtyCheck } from '~/hooks';

const UL = styled.ul`
  li:not(:first-child) {
    margin-top: 0.75rem;
  }
`;

export default function ColumnsDrawer({
  value = [],
  onClose,
  onApply,
  columns: availableColumns = [],
  title = 'Columns',
  section = 'Display Columns',
}) {
  const [columns, setColumns] = useState(value);
  const [isDirty, setIsDirty] = useState(false);
  const dirtyCheck = useDirtyCheck(() => isDirty);

  const handleSubmit = () => {
    onApply(columns);
  };

  return (
    <Drawer
      isOpen
      title={title}
      width="40rem"
      onBeforeClose={({ setIsOpen }) => dirtyCheck(() => setIsOpen(false))}
      onClose={onClose}>
      {(closeDrawer) => {
        const handleCloseClick = () => dirtyCheck(() => closeDrawer());

        return (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Form.Section title={section}>
              <UL>
                {_.map(availableColumns, (column) => {
                  const checked = columns.includes(column.key);

                  return (
                    <li key={column.key}>
                      <Checkbox
                        label={column.name}
                        checked={column.disabled ? true : checked}
                        disabled={column.disabled}
                        onChange={({ target: { checked } }) => {
                          setColumns((prev) => {
                            return checked ? [...prev, column.key] : prev.filter((key) => key !== column.key);
                          });
                          setIsDirty(true);
                        }}
                      />
                    </li>
                  );
                })}
              </UL>
            </Form.Section>

            <Drawer.Actions>
              <Buttons align="right">
                <CancelButton onClick={handleCloseClick}>Close</CancelButton>

                <Button type="submit" onClick={handleSubmit}>
                  Apply
                </Button>
              </Buttons>
            </Drawer.Actions>
          </div>
        );
      }}
    </Drawer>
  );
}
